module.exports = __webpack_public_path__ + "img/Comparative_Productivity.1396ce59.jpeg";